import React, { useEffect, useState, Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./scss/style.scss";
import { loginUser } from "./store/services/operations/loginAPi";
import CommonLoader from "./components/commonLoader";
import { userProfile } from "./store/services/operations/userProfile";

// Lazy-loaded components
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated) {
        try {
          await dispatch(loginUser()).unwrap();
          navigate("/profile");
        } catch (error) {
          const frontendUrl = process.env.REACT_APP_FRONTEND_URL || 'http://www.katalisia.com';
          window.location.href = frontendUrl;
        } finally {
          setIsCheckingAuth(false);
        }
      } else {
        setIsCheckingAuth(false);
      }
    };

    checkAuth();
  }, [dispatch, isAuthenticated, navigate]);

  useEffect(() => {
    dispatch(userProfile({ actionType: "list" }));
  }, [dispatch]);

  if (isCheckingAuth) {
    return <CommonLoader />;
  }

  const loading = (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );

  return (
    <Suspense fallback={loading}>
      <Routes>
        {!isAuthenticated ? (
          <Route path="/404" element={<Page404 />} />
        ) : (
          <Route path="*" element={<DefaultLayout />} />
        )}
      </Routes>
    </Suspense>
  );
};

export default App;
